const CryptoJS = require("crypto-js");
const config = require('../config/config.js');
const { aes } = config;

export default {
  setIsLogin(state) {
    if (typeof localStorage.getItem('dataUser') !== 'undefined' && localStorage.getItem('dataUser') !== null) {
      state.isLogin = true;
    } else {
      state.isLogin = false;
    }
  },
  setDataUser(state) {
    if (state.isLogin) {
      let bytes = CryptoJS.AES.decrypt(localStorage.getItem('dataUser').toString(), aes);
      let dataUser = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      state.dataUser = dataUser;
    }
  },
};
